import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { GoogleMap } from '@angular/google-maps';
import { Observable } from 'rxjs';

import { ApiProject } from '../../api-client-module';
import { UploadedFile } from '../../firestore-models/uploaded-file';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { SpinnerService } from '../../services/spinner.service';
import { ConfigurationService } from '../../configuration.service';
import { ApiClientService } from '../../api-client.service';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';
import { ApiSetProjectsRequest } from '../../api-client-module';
import { MultiAppnameDialogComponent } from '../../common/multi-appname-dialog/multi-appname-dialog.component';

export interface ProjectDialogData {
  change_type: number;
  project?: ApiProject;
}

export interface marker {
  lat: number;
  lng: number;
  draggable: boolean;
}

@Component({
  selector: 'app-project-dialog',
  templateUrl: './project-dialog.component.html',
  styleUrls: ['./project-dialog.component.css'],
  standalone: false,
})
export class ProjectDialogComponent implements OnInit {

  //プロジェクト情報
  project?: ApiProject;
  projectLanguages!: Array<ProjectLanguage>;

  //プロジェクト情報フォーム
  projectFormGroup!: FormGroup;
  projectIdControl!: FormControl;
  projectNameControl!: FormControl;
  autoTransControl!: FormControl;
  projectAppNamesControl!: FormControl;
  projectDescControl!: FormControl;
  projectFlagControl!: FormControl;
  projectLatControl!: FormControl;
  projectLngControl!: FormControl;

  private uploadedFilesCollection!: AngularFirestoreCollection<UploadedFile>;
  uploadedFiles!: Observable<UploadedFile[]>;

  projectBaseLang: string = 'ja';

  //GoogleMap表示
  isInit: boolean = false;
  zoom = AppConst.ZOOM_INITIAL_VALUE;
  center!: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    disableDefaultUI: true
  };
  currentPosition!: google.maps.LatLngLiteral
  currentPositionMarkerOption: google.maps.MarkerOptions = {
    draggable: true
  };

  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  @ViewChild("mapSearchField") searchField!: ElementRef;
  @ViewChild("mapSearchFieldExecute") searchFieldExecute!: ElementRef;
  private searchFieldClear!: ElementRef;
  // @ViewChild("mapSearchFieldClear") searchFieldClear!: ElementRef;
  @ViewChild("mapSearchFieldClear", { static: false }) set contentMapSearchFieldClear(contentMapSearchFieldClear: ElementRef) {
    if(contentMapSearchFieldClear) { 
      this.searchFieldClear = contentMapSearchFieldClear;
      if (!this.isInit) {
        this.searchBox = new google.maps.places.SearchBox(
          this.searchField.nativeElement
        );
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
          this.searchField.nativeElement
        );
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
          this.searchFieldExecute.nativeElement
        );
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
          this.searchFieldClear.nativeElement
        );
      }
    }
  }
  searchBox!: google.maps.places.SearchBox;

  constructor(
    public dialogRef: MatDialogRef<ProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ProjectDialogData,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    // private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,

  ) {}

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.project = this.data.project;
    if (this.project && !this.project.latitude) {
      this.project.latitude = AppConst.LATITUDE_INITIAL_VALUE;
    }
    if (this.project && !this.project.longitude) {
      this.project.longitude = AppConst.LONGITUDE_INITIAL_VALUE;
    }
    this.createForm();
    this.projectIdControl = this.projectFormGroup.get('projectId') as FormControl;
    this.projectNameControl = this.projectFormGroup.get('projectName') as FormControl;
    this.projectAppNamesControl = this.projectFormGroup.get('projectAppNames') as FormControl;
    this.projectDescControl = this.projectFormGroup.get('projectDesc') as FormControl;
    this.projectFlagControl = this.projectFormGroup.get('projectFlag') as FormControl;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang;
    this.projectLatControl = this.projectFormGroup.get('projectLat') as FormControl;
    this.projectLngControl = this.projectFormGroup.get('projectLng') as FormControl;

    this.currentPosition = {
      lat: this.project && this.project.latitude! ? this.project.latitude! : AppConst.LATITUDE_INITIAL_VALUE,
      lng: this.project && this.project.longitude! ? this.project.longitude! : AppConst.LONGITUDE_INITIAL_VALUE
    }
    this.center = this.currentPosition;
  }

  //フォームの値を各要素に代入
  private createForm() {
    this.projectFormGroup = this.formBuilder.group(
      {
        projectId: [this.project!.project_id],
        projectName: [this.project!.project_name],
        projectAppNames: [this.project!.project_app_names,],
        projectDesc: [this.project!.project_desc],
        projectLat: [this.project!.latitude, [Validators.required, Validators.min(-90), Validators.max(90), Validators.pattern('^(\-)?([1-9][0-9]{0,1}|0)(\.[0-9]{1,8})?$')]],
        projectLng: [this.project!.longitude, [Validators.required, Validators.min(-180), Validators.max(180), Validators.pattern('^(\-)?([1-9][0-9]{0,2}|0)(\.[0-9]{1,8})?$')]],
        projectColor: [],
        projectFlag: [this.project!.maintenance_flag]
      }
    );
  }

  //プロジェクト情報編集
  editProject(): void {
    if (this.projectFormGroup.valid) {
      this.project!.project_app_names = this.projectAppNamesControl.value;
      this.project!.project_desc = this.projectDescControl.value;
      this.project!.maintenance_flag = this.projectFlagControl.value;
      this.project!.latitude = this.projectLatControl.value;
      this.project!.longitude = this.projectLngControl.value;
      if (this.project) {
        let request: ApiSetProjectsRequest = {
          access_token: '',
          change_type: this.data.change_type,
          projects: [this.project]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setProjects(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じIDが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  //アプリ表示名ダイアログ
  openAppNamesDialog(): void {
    const dialogRef = this.dialog.open(MultiAppnameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.project!.project_app_names }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.project!.project_app_names = result;
        this.projectAppNamesControl.setValue(this.project!.project_app_names);
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public getErrorMessageToProjectLat() {
    return this.projectLatControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.projectLatControl.hasError('pattern') || this.projectLatControl.hasError('min') || this.projectLatControl.hasError('max')
          ? this.translate.instant('-90から90の間で小数第８位まで')
          : '';
  }

  public getErrorMessageToProjectLng() {
    return this.projectLngControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.projectLngControl.hasError('pattern') || this.projectLngControl.hasError('min') || this.projectLngControl.hasError('max')
          ? this.translate.instant('-180から180の間で小数第８位まで')
          : '';
  }

  // マップ検索用のキー制御
  onKeyDownFromSearchPlace(keyCode: number): boolean {
    if (keyCode && keyCode === 13) {
      // NOTE: Enterを叩かれると他の項目の編集ボタンが反応してしまうのを防ぐ
      return false;
    }
    return true;
  }

  // マップ検索
  searchMap(): void {
    const places = this.searchBox.getPlaces();
    if (places!.length === 0) {
      return;
    }
    const bounds = new google.maps.LatLngBounds();
    places!.forEach(place => {
      if (!place.geometry || !place.geometry.location) {
        return;
      }
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });
    this.projectLatControl.setValue(this.round(bounds.getCenter().lat(), 8));
    this.projectLngControl.setValue(this.round(bounds.getCenter().lng(), 8));
    this.currentPosition = {
      lat: this.round(bounds.getCenter().lat(), 8),
      lng: this.round(bounds.getCenter().lng(), 8)
    }
    this.map.panTo(this.currentPosition);
  }

  // マップ検索フィールドクリア
  clearMapSearchField(): void {
    this.searchField.nativeElement.value = "";
  }

  //GoogleMap上のピンとフォームの値を一致させる
  onMerkerDragEnd(event: any) {
    this.projectLatControl.setValue(this.round(event.latLng!.lat(), 8));
    this.projectLngControl.setValue(this.round(event.latLng!.lng(), 8));
  }

  //ピンの位置
  private round(value: number, digits: number): number {
    let pow: number = 1;
    if (digits > 0) {
      pow = Math.pow(10, digits);
    }
    return Math.round(value * pow) / pow;
  }

  //Googleマップと緯度のフォーム連携
  onBlurMarkerLat() {
    if (!!this.projectLatControl.valid) {
      this.projectLatControl.setValue(this.round(this.projectLatControl.value, 8));
      this.currentPosition = {
        lat: this.round(this.projectLatControl.value, 8),
        lng: this.currentPosition.lng
      }
      this.map.panTo(this.currentPosition);
    }
  }

  //Googleマップと経度のフォーム連携
  onBlurMarkerLng() {
    if (!!this.projectLngControl.valid) {
      this.projectLngControl.setValue(this.round(this.projectLngControl.value, 8));
      this.currentPosition = {
        lat: this.currentPosition.lat,
        lng: this.round(this.projectLngControl.value, 8)
      }
      this.map.panTo(this.currentPosition);
    }
  }

}
